import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageShell, { PageIntro } from "@/components/PageShell";
import posts from "@/data/blogPosts.json";

export const formatDate = (iso) =>
    iso ? new Date(`${iso}T00:00:00`).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" }) : "";

export const sortedPosts = [...posts].sort((a, b) => (b.date || "").localeCompare(a.date || ""));

export default function Blog() {
    return (
        <PageShell testId="blog-page">
            <PageIntro eyebrow="Blog" title="PayMe Blog" lead="News and guides for contractors and recruitment companies from PayMe." />
            <div className="mx-auto max-w-7xl px-5 pb-20 md:px-8">
                <ul className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="blog-list">
                    {sortedPosts.map((p) => (
                        <li key={p.slug}>
                            <Link to={`/blog/${p.slug}`} className="group flex h-full flex-col rounded-lg border border-border bg-white p-6 transition-shadow hover:shadow-md" data-testid={`blog-card-${p.slug}`}>
                                <time dateTime={p.date} className="text-sm text-muted-foreground">{formatDate(p.date)}</time>
                                <h2 className="mt-2 font-display text-xl font-bold leading-snug text-primary">{p.title}</h2>
                                <p className="mt-3 line-clamp-3 flex-1 text-base text-foreground/80">{p.excerpt}</p>
                                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
                                    Read article <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                                </span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </PageShell>
    );
}
